'use strict';

exports.__esModule = true;
exports.withAsyncHandlers = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _actionHelpers = require('./actionHelpers');

var _asyncHelpers = require('./asyncHelpers');

var _effects = require('redux-saga/effects');

var _withSagas = require('./withSagas');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var handlerTakers = {
  successHandler: _actionHelpers.toSuccess,
  errorHandler: _actionHelpers.toError,
  pendingHandler: _actionHelpers.toRequest
};
var handlerProps = (0, _ramda.keys)(handlerTakers);

var getHandlerPattern = function getHandlerPattern(asyncAction, actionType, getProps) {
  return function (takedAction) {
    if (takedAction.type === actionType) {
      var props = getProps();
      return (0, _ramda.equals)((0, _asyncHelpers.callWithProps)(asyncAction.params, props), takedAction.requestAction.params);
    }

    return false;
  };
};

var withAsyncHandlers = exports.withAsyncHandlers = function withAsyncHandlers(actionsConfig) {
  return function (WrappedComponent) {
    return function (_Component) {
      _inherits(_class, _Component);

      function _class(props) {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

        var actions = (0, _asyncHelpers.getActions)(props, actionsConfig);
        var sagas = [];
        (0, _ramda.forEachObjIndexed)(function (action, actionName) {
          (0, _ramda.when)((0, _ramda.prop)('saga'), function (action) {
            sagas.push(action.saga);
          }, action);
          var actionHandlers = (0, _ramda.pick)(handlerProps, action);
          (0, _ramda.forEachObjIndexed)(function (handler, key) {
            var actionType = handlerTakers[key] && handlerTakers[key]((0, _ramda.pathOr)(action.type, [actionName, 'type'], props));

            if (handler && actionType) {
              sagas.push(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee2(getProps) {
                var pattern;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        pattern = getHandlerPattern(action, actionType, getProps);
                        _context2.next = 3;
                        return (0, _effects.takeEvery)(pattern,
                        /*#__PURE__*/
                        _regenerator2.default.mark(function _callee(takedAction) {
                          return _regenerator2.default.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  _context.next = 2;
                                  return handler(getProps(), takedAction);

                                case 2:
                                case 'end':
                                  return _context.stop();
                              }
                            }
                          }, _callee, this);
                        }));

                      case 3:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, this);
              }));
            }
          }, actionHandlers);
        }, actions);
        _this.Component = (0, _withSagas.withSagas)(sagas)(WrappedComponent);
        return _this;
      }

      _createClass(_class, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(this.Component, this.props);
        }
      }]);

      return _class;
    }(_react.Component);
  };
};